import classNames from 'classnames/bind';
import { SubnetApiEntity } from 'cloud-networks/modules/SubnetModule/SubnetModule.types';
import React from 'react';
import { networksUtils } from 'services/cloud-networks/modules/networksModule/networksUtils';

import { DropdownOption } from 'reactComponents/Dropdown/Dropdown';
import {
    FieldSelect,
    FieldSelectProps,
} from 'reactComponents/Forms/FieldSelect';
import { FieldSubnetUtils } from 'reactComponents/Forms/FieldSubnet/FieldSubnet.utils';

import styles from './FieldSubnet.css';

const css = classNames.bind(styles);

type Props = FieldSelectProps & {
    subnets: SubnetApiEntity[];
    networks: any[];
    options: DropdownOption[];
};

export class FieldSubnet extends React.PureComponent<Props> {
    static getFirstAvailableSubnetId =
        FieldSubnetUtils.getFirstAvailableSubnetId;

    static getOptions = FieldSubnetUtils.getOptions;
    static getFirstNotNewOption = FieldSubnetUtils.getFirstNotNewOption;
    static NEW_NETWORK_VALUE = FieldSubnetUtils.NEW_NETWORK_OPTION.value;

    _renderSelectedValue = (netOrSubnetId) => {
        if (netOrSubnetId === FieldSubnet.NEW_NETWORK_VALUE) {
            return 'Создать новую сеть';
        }

        const subnet = this.props.subnets.find(
            (subnet) => subnet.id === netOrSubnetId,
        );
        const subnetName = subnet?.name || subnet?.id;
        const networkId = subnet?.network_id || netOrSubnetId;

        const network = this.props.networks.find(
            (item) => item.id === networkId,
        );

        const networkName = networksUtils.getNetworkName(network);

        const privateDnsDomain = network?.private_dns_domain;

        return (
            <span className={css('networkDropdown', { hasSubnet: subnetName })}>
                {networkName && (
                    <span className={css('network')}>{networkName}</span>
                )}
                {networkName && subnetName && (
                    <span className={css('colon')}>:</span>
                )}

                {subnetName && (
                    <>
                        &nbsp;
                        <span className={css('subnet')}>{subnetName}</span>
                    </>
                )}
                {privateDnsDomain && (
                    <span className={css('privateDnsDomain')}>
                        {privateDnsDomain}
                    </span>
                )}
            </span>
        );
    };

    render() {
        const { networks, subnets, options, ...otherSelectProps } = this.props;
        return (
            <FieldSelect
                {...{
                    options,
                    selectedValueCustomRender: this._renderSelectedValue,
                    ...otherSelectProps,
                }}
            />
        );
    }
}
